import React, {useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Field} from 'formik';
import ColorField from '../../../../../components/product/color/colorfield';
import InputBox from '../../../../../components/formik/InputBox';
import _get from 'lodash/get';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import Select from 'react-select';
import ImageField from '../../../../../components/formik/ImageField';
import classnames from 'classnames';
import ToggleEnableField from '../../../components/togglernablefield';
import CheckBoxGroup from '../../../../../components/formik/CheckBoxGroup';
import CheckBox from '../../../../../components/formik/CheckBox';
import langUtils from '../../../../../utils/langUtils';

export default function Recommendation({
  formikProps,
  width,
  displayRecommendLayout,
  imageType,
  setImageType,
}) {
  const {t} = useTranslation();
  return _get(formikProps.values, 'header.topTabs.enable') ? (
    <>
      <h3 className="kt-margin-b-20">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation">
          Recommendation
        </Trans>
      </h3>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.summary">
          Recommendation Summary
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show.recommendation.summary">
            Show Recommendation Summary
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8 m-auto">
          <Field
            name="skincareHtmlResult.recommendSummary.enable"
            value={_get(
              formikProps.values,
              'skincareHtmlResult.recommendSummary.enable'
            )}
            component={CustomSwitch}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.background">
            Background Image
          </Trans>
        </label>
        <div className="col-4 col-lg-8 col-md-8" style={{width: 'max-content'}}>
          <div>
            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.background.desc1">
              iPad: 2048W x 513H JPG recommended
            </Trans>
          </div>
          <div className="kt-margin-b-10">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.background.desc2">
              iPhone: 828W x 276H JPG recommended
            </Trans>
          </div>
          <div style={{width: 'max-content'}}>
            <div className="d-flex">
              <button
                type="button"
                style={{
                  flex: '1 1 auto',
                  width: '5%',
                  fontSize: '16px',
                  backgroundColor: imageType === 'pad' ? '#169bd5' : '',
                  color: imageType === 'pad' ? 'white' : '',
                }}
                onClick={() => setImageType('pad')}
              >
                <i className="fa fa-tablet" />{' '}
                <span>
                  <Trans i18nKey="p.s.u.c.preview.device.pad.portrait">
                    iPad - Portrait
                  </Trans>
                </span>
              </button>
              <button
                type="button"
                style={{
                  flex: '1 1 auto',
                  width: '5%',
                  fontSize: '16px',
                  borderLeft: 'none',
                  backgroundColor: imageType === 'mobile' ? '#169bd5' : '',
                  color: imageType === 'mobile' ? 'white' : '',
                }}
                onClick={() => setImageType('mobile')}
              >
                <i className="fa fa-mobile" />{' '}
                <span>
                  <Trans i18nKey="p.s.u.c.preview.device.phone.portrait">
                    iPhone - Portrait
                  </Trans>
                </span>
              </button>
            </div>
            <div
              className="d-flex justify-content-center"
              style={{
                border: 'dashed',
                borderTop: 'none',
                width: 'max-content',
              }}
            >
              <div style={{margin: '20px'}}>
                {imageType === 'mobile' && (
                  <Field
                    name="skincareHtmlResult.recommendSummary.backgroundImage[0].image"
                    imageUrl={_get(
                      formikProps.values,
                      'skincareHtmlResult.recommendSummary.backgroundImage[0].image'
                    )}
                    scaleImage={true}
                    clearFormFields={[
                      'skincareHtmlResult.recommendSummary.backgroundImage[0].image',
                      'skincareHtmlResult.recommendSummary.backgroundImage[0].url',
                    ]}
                    component={ImageField}
                    width={828}
                    height={276}
                    maxWidth={414}
                    maxHeight={138}
                  />
                )}
                {imageType === 'pad' && (
                  <Field
                    name="skincareHtmlResult.recommendSummary.backgroundImage[1].image"
                    imageUrl={_get(
                      formikProps.values,
                      'skincareHtmlResult.recommendSummary.backgroundImage[1].image'
                    )}
                    scaleImage={true}
                    clearFormFields={[
                      'skincareHtmlResult.recommendSummary.backgroundImage[1].image',
                      'skincareHtmlResult.recommendSummary.backgroundImage[1].url',
                    ]}
                    component={ImageField}
                    width={2048}
                    height={512}
                    maxWidth={412}
                    maxHeight={103}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="form-group row" style={{alignItems: 'center'}}>
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.recommendation.summary">
            Recommendation Summary
          </Trans>
        </label>
        <div
          className="col-9  col-lg-8 col-md-8 row"
          style={{display: width >= 1366 ? 'flex' : 'block'}}
        >
          <div
            className={classnames({
              'col-3': width >= 1366,
              'col-12': width < 1366,
            })}
          >
            <Select
              options={langUtils.getAppLangList()}
              onChange={o => {
                formikProps.setFieldValue(
                  'skincareHtmlResult.recommendSummary.contentLanguage',
                  o
                );
              }}
              value={_get(
                formikProps.values,
                'skincareHtmlResult.recommendSummary.contentLanguage'
              )}
              isSearchable={false}
              isClearable={false}
              placeholder={
                <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
              }
            />
          </div>
          <div
            className={classnames({
              'col-6': width >= 1366,
              'col-12': width < 1366,
            })}
          >
            <Field
              name={`skincareHtmlResult.recommendSummary.contentI18n.${_get(
                formikProps.values,
                'skincareHtmlResult.recommendSummary.contentLanguage.value'
              )}`}
              placeholder={t(
                'p.c.addrequest.description.placeholder',
                'Please include detailed description of the issue or error message. If possible, please attach a screenshot.'
              )}
              component={InputBox}
            />
          </div>
        </div>
      </div>
      <div className="form-group row" style={{alignItems: 'center'}}>
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.text.color">
            Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.recommendSummary.textColor"
            component={ColorField}
          />
        </div>
      </div>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.tabsettings">
          Recommendation Tab Settings
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.setting.desc">
          Select which tabs are enabled and their display order on
          Recommendation page.
        </Trans>
      </div>
      <Field name="skincareHtmlResult.recommendSummary.layout">
        {props => (
          <div className="form-group  flex__block flex__item-align-center flex__flow-wrap">
            <div className="col-md-12">
              <ToggleEnableField
                itemList={displayRecommendLayout}
                onChange={list => {
                  const seqList = [...list];
                  props.form.setFieldValue(props.field.name, seqList);
                  props.form.setFieldValue(
                    'skincareHtmlResult.recommendSummary.layoutItems',
                    seqList.filter(r => r.disabled === false)
                  );
                }}
                minEnable={1}
                type={'SKIN_ANALYSIS'}
              />
            </div>
          </div>
        )}
      </Field>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="skincareHtmlResult.recommendSummary.tabcolor.settings">
          Tab Color Settings
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="skincareHtmlResult.recommendSummary.tabcolor.enabletab.onclick">
            Enabled Tab - On Click
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.recommendSummary.tabColor.selectedBackgroundColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="skincareHtmlResult.recommendSummary.tabColor.textcolor.enabledtab.onclick">
            Text Color of Enabled Tab - On Click
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.recommendSummary.tabColor.selectedTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="skincareHtmlResult.recommendSummary.tabColor.enabledtab.default">
            Enabled Tab - Default
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.recommendSummary.tabColor.backgroundColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="skincareHtmlResult.recommendSummary.tabColor.textcolor.enabledtab.default">
            Text Color of Enabled Tab - Default
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.recommendSummary.tabColor.textColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="skincareHtmlResult.recommendSummary.tabColor.disabledtab.onclick">
            Disabled Tab - On Click
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.recommendSummary.tabColor.selectedDisabledBackgroundColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="skincareHtmlResult.recommendSummary.tabColor.textcolor.disabledtab.onclick">
            Text Color of Disabled Tab - On Click
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.recommendSummary.tabColor.selectedDisabledTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="skincareHtmlResult.recommendSummary.tabColor.disabledtab.default">
            Disabled Tab - Default
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.recommendSummary.tabColor.disabledBackgroundColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="skincareHtmlResult.recommendSummary.tabColor.textcolor.disabledtab.default">
            Text Color of Disabled Tab - Default
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.recommendSummary.tabColor.disabledTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <h5 className="kt-margin-b-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.product.recommendation">
          Product Recommendation
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
            Background Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.productRecommend.backgroundColor"
            component={ColorField}
          />
        </div>
      </div>
      <div
        className="kt-margin-t-10 kt-margin-b-10 kt-padding-10"
        style={{border: '1px solid #D3D3D3'}}
      >
        <h6 className="kt-margin-t-10">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.heading.area">
            Heading Area
          </Trans>
        </h6>
        <div className="form-group row" style={{alignItems: 'center'}}>
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.heading.text">
              Heading Text
            </Trans>
          </label>
          <div
            className="col-9  col-lg-8 col-md-8 row"
            style={{display: width >= 1366 ? 'flex' : 'block'}}
          >
            <div
              className={classnames({
                'col-3': width >= 1366,
                'col-12': width < 1366,
              })}
            >
              <Select
                options={langUtils.getAppLangList()}
                onChange={o => {
                  formikProps.setFieldValue(
                    'skincareHtmlResult.productRecommend.heading.textLanguage',
                    o
                  );
                }}
                value={_get(
                  formikProps.values,
                  'skincareHtmlResult.productRecommend.heading.textLanguage'
                )}
                isSearchable={false}
                isClearable={false}
                placeholder={
                  <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
                }
              />
            </div>
            <div
              className={classnames({
                'col-6': width >= 1366,
                'col-12': width < 1366,
              })}
            >
              <Field
                name={`skincareHtmlResult.productRecommend.heading.textI18n.${_get(
                  formikProps.values,
                  'skincareHtmlResult.productRecommend.heading.textLanguage.value'
                )}`}
                component={InputBox}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.heading.text.color">
              Heading Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.heading.textColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.category.text.color">
              Category Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.heading.categoryTextColor"
              component={ColorField}
            />
          </div>
        </div>
      </div>
      <div
        className="kt-margin-t-10 kt-margin-b-10 kt-padding-10"
        style={{border: '1px solid #D3D3D3'}}
      >
        <h6 className="kt-margin-t-10">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.product.card">
            Product Card
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.display">
              Product info Display
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-6' : 'col-8'}>
            {formikProps.values && (
              <CheckBoxGroup
                id="skincareHtmlResult.productRecommend.enabledInfo"
                columnClasses={['col-6', 'col-6']}
                {...formikProps}
              >
                {[
                  {
                    hide: false,
                    value: 'brandName',
                    label: (
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.business">
                        Business Name
                      </Trans>
                    ),
                  },
                  {
                    hide: true,
                    value: 'productName',
                    label: (
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.product">
                        Product Name
                      </Trans>
                    ),
                  },
                  {
                    hide: true,
                    value: 'productDesc',
                    label: (
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.product.desc">
                        Product Description
                      </Trans>
                    ),
                  },
                ].map((r, i) => (
                  <Field
                    key={i}
                    id={r.value}
                    label={r.label}
                    component={CheckBox}
                    hide={r.hide}
                  />
                ))}
              </CheckBoxGroup>
            )}
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.border.color">
              Border Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.productCard.backgroundColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.background.color">
              Border Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.productCard.borderColor"
              component={ColorField}
            />
          </div>
        </div>
        <h6 className="kt-margin-l-50 ">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.business.name">
            Business Name
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.name.text.color">
              Name Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.productCard.brandNameTextColor"
              component={ColorField}
            />
          </div>
        </div>
        <h6 className="kt-margin-l-50">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.product.name">
            Product Name
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.name.text.color">
              Name Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.productCard.productNameTextColor"
              component={ColorField}
            />
          </div>
        </div>
        <h6 className="kt-margin-l-50">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.more.info.icon">
            More Info Icon
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 " />
          <div className="col-4 col-lg-8 col-md-8">
            <Field
              name="skincareHtmlResult.productRecommend.productCard.moreInfoIcon.image"
              imageUrl={_get(
                formikProps.values,
                'skincareHtmlResult.productRecommend.productCard.moreInfoIcon.image'
              )}
              scaleImage={true}
              clearFormFields={[
                'skincareHtmlResult.productRecommend.productCard.moreInfoIcon.image',
                'skincareHtmlResult.productRecommend.productCard.moreInfoIcon.url',
              ]}
              component={ImageField}
              width={200}
              height={200}
              maxWidth={width > 1024 ? 200 : 100}
              maxHeight={width > 1024 ? 200 : 100}
            />
          </div>
        </div>
      </div>
      <div
        className="kt-margin-t-10 kt-margin-b-30 kt-padding-10"
        style={{border: '1px solid #D3D3D3'}}
      >
        <h6 className="kt-margin-t-10">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.product.card.popup">
            Product Card Pop-Up
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.image.border.color">
              Image Border Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.productCard.popup.imageBorderColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.business.name.color">
              Business Name Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.productCard.popup.brandNameColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.name.color">
              Product Name Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.productCard.popup.productNameColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.description.color">
              Product Description Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.productCard.popup.productDescriptionColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.button.color">
              Button Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.productRecommend.productCard.popup.buttonColor"
              component={ColorField}
            />
          </div>
        </div>
      </div>
      <h5 className="kt-margin-b-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.routine.recommendation">
          Routine Recommendation
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
            Background Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.routineRecommend.backgroundColor"
            component={ColorField}
          />
        </div>
      </div>
      <div
        className="kt-margin-t-10 kt-margin-b-10 kt-padding-10"
        style={{border: '1px solid #D3D3D3'}}
      >
        <h6 className="kt-margin-t-10">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.heading.area">
            Heading Area
          </Trans>
        </h6>
        <div className="form-group row" style={{alignItems: 'center'}}>
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.heading.text">
              Heading Text
            </Trans>
          </label>
          <div
            className="col-9  col-lg-8 col-md-8 row"
            style={{display: width >= 1366 ? 'flex' : 'block'}}
          >
            <div
              className={classnames({
                'col-3': width >= 1366,
                'col-12': width < 1366,
              })}
            >
              <Select
                options={langUtils.getAppLangList()}
                onChange={o => {
                  formikProps.setFieldValue(
                    'skincareHtmlResult.routineRecommend.heading.textLanguage',
                    o
                  );
                }}
                value={_get(
                  formikProps.values,
                  'skincareHtmlResult.routineRecommend.heading.textLanguage'
                )}
                isSearchable={false}
                isClearable={false}
                placeholder={
                  <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
                }
              />
            </div>
            <div
              className={classnames({
                'col-6': width >= 1366,
                'col-12': width < 1366,
              })}
            >
              <Field
                name={`skincareHtmlResult.routineRecommend.heading.textI18n.${_get(
                  formikProps.values,
                  'skincareHtmlResult.routineRecommend.heading.textLanguage.value'
                )}`}
                component={InputBox}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.heading.text.color">
              Heading Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.heading.block.titleTextColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.routine.name.color">
              Routine Name Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.heading.block.categoryTextColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.step.color">
              Step Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.heading.block.stepTextColor"
              component={ColorField}
            />
          </div>
        </div>
      </div>
      <div
        className="kt-margin-t-10 kt-margin-b-10 kt-padding-10"
        style={{border: '1px solid #D3D3D3'}}
      >
        <h6 className="kt-margin-t-10">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.product.card">
            Product Card
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.display">
              Product info Display
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-6' : 'col-8'}>
            <CheckBoxGroup
              id="skincareHtmlResult.routineRecommend.enabledInfo"
              columnClasses={['col-6', 'col-6']}
              formik={formikProps}
            >
              {[
                {
                  hide: false,
                  value: 'brandName',
                  label: (
                    <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.business">
                      Business Name
                    </Trans>
                  ),
                },
                {
                  hide: true,
                  value: 'productName',
                  label: (
                    <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.product">
                      Product Name
                    </Trans>
                  ),
                },
                {
                  hide: true,
                  value: 'productDesc',
                  label: (
                    <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.product.desc">
                      Product Description
                    </Trans>
                  ),
                },
              ].map((r, i) => (
                <Field
                  key={i}
                  id={r.value}
                  label={r.label}
                  component={CheckBox}
                  hide={r.hide}
                />
              ))}
            </CheckBoxGroup>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.border.color">
              Border Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.productCard.backgroundColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.background.color">
              Border Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.productCard.borderColor"
              component={ColorField}
            />
          </div>
        </div>
        <div id="recommendation" />
        <h6 className="kt-margin-l-50 ">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.business.name">
            Business Name
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.name.text.color">
              Name Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.productCard.brandNameTextColor"
              component={ColorField}
            />
          </div>
        </div>
        <h6 className="kt-margin-l-50">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.product.name">
            Product Name
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.name.text.color">
              Name Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.productCard.productNameTextColor"
              component={ColorField}
            />
          </div>
        </div>
        <h6 className="kt-margin-l-50">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.more.info.icon">
            More Info Icon
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 " />
          <div className="col-4 col-lg-8 col-md-8">
            <Field
              name="skincareHtmlResult.routineRecommend.productCard.moreInfoIcon.image"
              imageUrl={_get(
                formikProps.values,
                'skincareHtmlResult.routineRecommend.productCard.moreInfoIcon.image'
              )}
              scaleImage={true}
              clearFormFields={[
                'skincareHtmlResult.routineRecommend.productCard.moreInfoIcon.image',
                'skincareHtmlResult.routineRecommend.productCard.moreInfoIcon.url',
              ]}
              component={ImageField}
              width={200}
              height={200}
              maxWidth={width > 1024 ? 200 : 100}
              maxHeight={width > 1024 ? 200 : 100}
            />
          </div>
        </div>
      </div>
      <div
        className="kt-margin-t-10 kt-margin-b-30 kt-padding-10"
        style={{border: '1px solid #D3D3D3'}}
      >
        <h6 className="kt-margin-t-10">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.product.card.popup">
            Product Card Pop-Up
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.image.border.color">
              Image Border Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.productCard.popup.imageBorderColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.business.name.color">
              Business Name Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.productCard.popup.brandNameColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.name.color">
              Product Name Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.productCard.popup.productNameColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.description.color">
              Product Description Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.productCard.popup.productDescriptionColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.button.color">
              Button Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.routineRecommend.productCard.popup.buttonColor"
              component={ColorField}
            />
          </div>
        </div>
      </div>
      <h5 className="kt-margin-b-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation.treatment.recommendation">
          Treatment Recommendation
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
            Background Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.treatmentRecommend.backgroundColor"
            component={ColorField}
          />
        </div>
      </div>
      <div
        className="kt-margin-t-10 kt-margin-b-10 kt-padding-10"
        style={{border: '1px solid #D3D3D3'}}
      >
        <h6 className="kt-margin-t-10">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.heading.area">
            Heading Area
          </Trans>
        </h6>
        <div className="form-group row" style={{alignItems: 'center'}}>
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.heading.text">
              Heading Text
            </Trans>
          </label>
          <div
            className="col-9  col-lg-8 col-md-8 row"
            style={{display: width >= 1366 ? 'flex' : 'block'}}
          >
            <div
              className={classnames({
                'col-3': width >= 1366,
                'col-12': width < 1366,
              })}
            >
              <Select
                options={langUtils.getAppLangList()}
                onChange={o => {
                  formikProps.setFieldValue(
                    'skincareHtmlResult.treatmentRecommend.heading.textLanguage',
                    o
                  );
                }}
                value={_get(
                  formikProps.values,
                  'skincareHtmlResult.treatmentRecommend.heading.textLanguage'
                )}
                isSearchable={false}
                isClearable={false}
                placeholder={
                  <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
                }
              />
            </div>
            <div
              className={classnames({
                'col-6': width >= 1366,
                'col-12': width < 1366,
              })}
            >
              <Field
                name={`skincareHtmlResult.treatmentRecommend.heading.textI18n.${_get(
                  formikProps.values,
                  'skincareHtmlResult.treatmentRecommend.heading.textLanguage.value'
                )}`}
                component={InputBox}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.heading.text.color">
              Heading Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.heading.textColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.category.text.color">
              Category Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.heading.categoryTextColor"
              component={ColorField}
            />
          </div>
        </div>
      </div>
      <div
        className="kt-margin-t-10 kt-margin-b-10 kt-padding-10"
        style={{border: '1px solid #D3D3D3'}}
      >
        <h6 className="kt-margin-t-10">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.treatment.card">
            Treatment Card
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.treatment.info.display">
              Treatment info Display
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-6' : 'col-8'}>
            <CheckBoxGroup
              id="skincareHtmlResult.treatmentRecommend.enabledInfo"
              columnClasses={['col-6', 'col-6']}
              formik={formikProps}
            >
              {[
                {
                  hide: false,
                  value: 'brandName',
                  label: (
                    <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.business">
                      Business Name
                    </Trans>
                  ),
                },
                {
                  hide: true,
                  value: 'productName',
                  label: (
                    <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.product">
                      Product Name
                    </Trans>
                  ),
                },
                {
                  hide: true,
                  value: 'productDesc',
                  label: (
                    <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.info.product.desc">
                      Product Description
                    </Trans>
                  ),
                },
              ].map((r, i) => (
                <Field
                  key={i}
                  id={r.value}
                  label={r.label}
                  component={CheckBox}
                  hide={r.hide}
                />
              ))}
            </CheckBoxGroup>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.border.color">
              Border Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.treatmentCard.backgroundColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.background.color">
              Border Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.treatmentCard.borderColor"
              component={ColorField}
            />
          </div>
        </div>
        <div id="recommendation" />
        <h6 className="kt-margin-l-50 ">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.business.name">
            Business Name
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.name.text.color">
              Name Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.treatmentCard.brandNameTextColor"
              component={ColorField}
            />
          </div>
        </div>
        <h6 className="kt-margin-l-50">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.treatment.name">
            Treatment Name
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.name.text.color">
              Name Text Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.treatmentCard.productNameTextColor"
              component={ColorField}
            />
          </div>
        </div>
        <h6 className="kt-margin-l-50">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.more.info.icon">
            More Info Icon
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 " />
          <div className="col-4 col-lg-8 col-md-8">
            <Field
              name="skincareHtmlResult.treatmentRecommend.treatmentCard.moreInfoIcon.image"
              imageUrl={_get(
                formikProps.values,
                'skincareHtmlResult.treatmentRecommend.treatmentCard.moreInfoIcon.image'
              )}
              scaleImage={true}
              clearFormFields={[
                'skincareHtmlResult.treatmentRecommend.treatmentCard.moreInfoIcon.image',
                'skincareHtmlResult.treatmentRecommend.treatmentCard.moreInfoIcon.url',
              ]}
              component={ImageField}
              width={200}
              height={200}
              maxWidth={width > 1024 ? 200 : 100}
              maxHeight={width > 1024 ? 200 : 100}
            />
          </div>
        </div>
      </div>
      <div
        className="kt-margin-t-10 kt-margin-b-30 kt-padding-10"
        style={{border: '1px solid #D3D3D3'}}
      >
        <h6 className="kt-margin-t-10">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.product.card.popup">
            Product Card Pop-Up
          </Trans>
        </h6>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.image.border.color">
              Image Border Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.treatmentCard.popup.imageBorderColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.business.name.color">
              Business Name Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.treatmentCard.popup.brandNameColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.treatment.name.color">
              Treatment Name Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.treatmentCard.popup.productNameColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.description.color">
              Product Description Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.treatmentCard.popup.productDescriptionColor"
              component={ColorField}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.product.button.color">
              Button Color
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-4' : 'col-8'}>
            <Field
              name="skincareHtmlResult.treatmentRecommend.treatmentCard.popup.buttonColor"
              component={ColorField}
            />
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
}
